import classNames from 'classnames'
import styles from './Checkbox.module.css'
import { CheckboxProps } from './types'
import { forwardRef, useId } from 'react'

const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(function Checkbox(
  {
    'id': id_,
    name,
    error = false,
    'classNames': externalStyles,
    'aria-disabled': ariaDisabled_,
    'aria-required': ariaRequired_,
    children,
    required,
    checked,
    disabled_,
    disabled,
    fullWidth,
    ...props
  }: CheckboxProps,
  ref
) {
  const generatedId = useId()
  const id = id_ || name || generatedId
  const ariaDisabled = ariaDisabled_ || disabled || disabled_

  return (
    <label
      htmlFor={id}
      className={classNames(styles.checkboxContainer, externalStyles?.label, {
        [styles.disabledLabel!]: disabled,
        ['fullWidth']: fullWidth && fullWidth !== 'mobile-only',
        ['fullWidthOnMobile']: fullWidth && fullWidth === 'mobile-only',
      })}
    >
      <div
        className={classNames(styles.checkboxWrapper, {
          ['fullWidth']: fullWidth && fullWidth !== 'mobile-only',
          ['fullWidthOnMobile']: fullWidth && fullWidth === 'mobile-only',
        })}
      >
        <div className={styles.checkbox}>
          <input
            tabIndex={0}
            {...props}
            type="checkbox"
            ref={ref}
            id={id}
            name={name}
            required={required}
            disabled={disabled_}
            aria-disabled={ariaDisabled}
            aria-required={required}
            aria-invalid={error}
            aria-checked={checked}
            aria-describedby={error ? `${name}-error` : undefined}
          />
          <span className={classNames(styles.checkmark, externalStyles?.checkmark)} />
        </div>
        <div className={classNames(styles.labelContent, externalStyles?.labelContent)}>{children}</div>
      </div>
    </label>
  )
})

export default Checkbox
